(function($) {
    'use strict';

    $(document).ready(function() {
        var $slider = $('.methodology__timeline');
        if (!$slider.length) return;

        var slickInitialized = false;

        function initMethodologySlider() {
            var windowWidth = window.innerWidth; // Matches CSS media query viewport width

            if (windowWidth <= 991) {
                if (!slickInitialized) {
                    // Ensure first slide is marked active initially if none are
                    if (!$slider.find('.methodology__step.is-active').length) {
                        $slider.find('.methodology__step').eq(0).addClass('is-active');
                    }

                    $slider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false,
                        adaptiveHeight: true,
                        autoplay: false
                    });

                    // Sync active slide class on slide change
                    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                        $slider.find('.methodology__step').removeClass('is-active');
                        $slider.find('.methodology__step').eq(nextSlide).addClass('is-active');
                        
                        // Update progress bar
                        var $progressBar = $('.methodology__progress-step');
                        $progressBar.removeClass('is-active');
                        for (var i = 0; i <= nextSlide; i++) {
                            $progressBar.eq(i).addClass('is-active');
                        }
                    });

                    // Click progress bar steps to navigate slides
                    $('.methodology__progress-step').on('click', function() {
                        var slideIndex = $(this).data('slide');
                        $slider.slick('slickGoTo', slideIndex);
                    });

                    slickInitialized = true;
                }
            } else {
                if (slickInitialized) {
                    // Clean up event listeners
                    $slider.off('beforeChange');
                    $('.methodology__progress-step').off('click');

                    // Destroy slick slider
                    $slider.slick('unslick');
                    slickInitialized = false;

                    // Restore original state: first step active, others inactive on desktop
                    $slider.find('.methodology__step').removeClass('is-active');
                    $slider.find('.methodology__step').eq(0).addClass('is-active');
                }
            }
        }

        // Run on load and resize
        initMethodologySlider();
        $(window).on('resize', function() {
            initMethodologySlider();
        });
    });

})(jQuery);
